<template>
  <div>
    <h4 class="titulo-component">Inscrição na Lista de Espera</h4>

    <div class="container-form" v-if="!protocoloGerado">

      <div v-if="carregando" style="text-align: center; padding: 30px;">
        <i class="el-icon-loading" style="font-size: 26px;"></i>
      </div>

      <!--
        FALHA DE CARGA E AUSÊNCIA DE PROCESSO SÃO COISAS DIFERENTES.

        Antes, qualquer erro na chamada deixava `processos` vazio e caía neste mesmo aviso:
        o cidadão lia "não há inscrição aberta" e ia embora, quando na verdade a API estava
        fora do ar ou apontada para o endereço errado. Numa página pública de matrícula,
        esse engano custa a vaga da criança.
      -->
      <el-alert v-else-if="erro" type="error" :closable="false" show-icon
        :title="erro"
        description="Isto é uma falha temporária do sistema, não o encerramento das inscrições. Tente novamente em alguns minutos ou procure a secretaria de educação."></el-alert>

      <el-alert v-else-if="processos.length === 0" type="info" :closable="false" show-icon
        title="Não há processo de inscrição aberto no momento."
        description="Assim que um novo período de inscrição for aberto, ele aparecerá aqui."></el-alert>

      <el-form v-else @submit.native.prevent="onSubmit" :model="dados" ref="dados" label-position="top">

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Processo de inscrição" prop="processo_inscricao_id" :rules="[$requiredChange]">
              <el-select v-model="dados.processo_inscricao_id" @change="selecionaProcesso" placeholder="Selecione">
                <el-option v-for="p in processos" :key="p.id" :value="p.id"
                  :label="p.nome + ' — inscrições até ' + formata(p.data_fim)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div v-if="dados.processo_inscricao_id">

          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item :label="rotuloEscolas" prop="instituicoes" :rules="[$requiredChange]">
                <el-select v-model="dados.instituicoes" multiple filterable
                  :multiple-limit="maxEscolas" placeholder="Selecione a(s) escola(s)">
                  <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <h5 class="subtitulo">Dados do candidato</h5>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="14" :md="14">
              <el-form-item label="Nome completo do candidato" prop="nome" :rules="[$requiredBlur]">
                <el-input v-model="dados.nome" maxlength="191"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="10" :md="10">
              <el-form-item label="Data de nascimento" prop="data_nascimento" :rules="[$requiredBlur, $dataBlur]">
                <el-input v-model="dados.data_nascimento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12">
              <el-form-item label="CPF do candidato (opcional)" prop="cpf">
                <el-input v-model="dados.cpf" v-mask="'###.###.###-##'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12">
              <el-form-item label="Nome do responsável" prop="nome_responsavel" :rules="[$requiredBlur]">
                <el-input v-model="dados.nome_responsavel" maxlength="191"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12">
              <el-form-item label="Telefone de contato" prop="telefone" :rules="[$requiredBlur]">
                <el-input v-model="dados.telefone" v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12">
              <el-form-item label="E-mail (opcional)" prop="email">
                <el-input v-model="dados.email" maxlength="191"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div v-if="campos.length">
            <h5 class="subtitulo">Informações complementares</h5>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" v-for="c in campos" :key="c.chave">
                <el-form-item :label="c.label + (c.obrigatorio ? ' *' : '')">
                  <el-select v-if="c.tipo === 'boolean'" v-model="dados.respostas_formulario[c.chave]" placeholder="Selecione">
                    <el-option value="1" label="Sim"></el-option>
                    <el-option value="0" label="Não"></el-option>
                  </el-select>
                  <el-input v-else-if="c.tipo === 'date'" v-model="dados.respostas_formulario[c.chave]"
                    v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                  <el-input v-else v-model="dados.respostas_formulario[c.chave]"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-alert v-if="erro" :title="erro" :closable="false" type="error" show-icon class="u-mt-10"></el-alert>

        <div class="container-btns">
          <el-button native-type="submit" type="primary" :loading="enviando" :disabled="!dados.processo_inscricao_id">
            Enviar inscrição
          </el-button>
        </div>
      </el-form>
    </div>

    <div class="container-form" v-else>
      <el-alert type="success" :closable="false" show-icon
        title="Inscrição registrada com sucesso!"></el-alert>

      <div class="protocolo-box">
        <span class="protocolo-label">Guarde o seu protocolo</span>
        <span class="protocolo-numero">{{ protocoloGerado.protocolo }}</span>
        <span class="protocolo-obs">
          Ele é necessário para consultar a sua posição na lista. Anote ou tire uma foto desta tela.
        </span>
      </div>

      <div class="container-btns">
        <router-link to="/lista-espera-consulta">
          <el-button type="primary">Consultar minha posição</el-button>
        </router-link>
        <router-link to="/">
          <el-button>Voltar ao início</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * BLOCO D — item 63 do edital (Timbé do Sul/SC): inscrição do cidadão na lista de espera.
 *
 * Endpoint PÚBLICO, sem autenticação. Toda a validação (janela de datas, canal, escolas
 * permitidas, campos obrigatórios do formulário, CPF duplicado) é do backend — a tela
 * apenas apresenta a mensagem que ele devolve.
 */
export default {
  data () {
    return {
      carregando: true,
      enviando: false,
      erro: '',
      processos: [],
      instituicoes: [],
      campos: [],
      maxEscolas: null,
      protocoloGerado: null,
      dados: {
        processo_inscricao_id: '',
        instituicoes: [],
        nome: '',
        data_nascimento: '',
        cpf: '',
        nome_responsavel: '',
        telefone: '',
        email: '',
        respostas_formulario: {}
      }
    }
  },
  computed: {
    rotuloEscolas () {
      return this.maxEscolas > 1
        ? 'Escolas de interesse (até ' + this.maxEscolas + ')'
        : 'Escola de interesse'
    }
  },
  mounted () {
    this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/processos`)
      .then(r => {
        this.processos = (r.data && r.data.processos) ? r.data.processos : []
        this.carregando = false
      })
      .catch(() => { this.carregando = false; this.erro = 'Não foi possível carregar os processos de inscrição.' })
  },
  methods: {
    formata (d) { return d ? String(d).substring(0, 10).split('-').reverse().join('/') : '' },
    selecionaProcesso () {
      this.erro = ''
      this.dados.instituicoes = []
      this.dados.respostas_formulario = {}

      const p = this.processos.find(x => x.id === this.dados.processo_inscricao_id)
      this.maxEscolas = p ? p.qtd_max_estabelecimentos : 1
      this.campos = (p && p.campos_formulario) ? p.campos_formulario : []

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/instituicoes/${this.dados.processo_inscricao_id}`)
        .then(r => { this.instituicoes = (r.data && r.data.instituicoes) ? r.data.instituicoes : [] })
        .catch(() => { this.instituicoes = [] })
    },
    onSubmit () {
      this.$refs.dados.validate(valid => {
        if (!valid) {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
          return
        }

        this.erro = ''
        this.enviando = true

        // A data vai no formato que a API espera; o resto segue como o usuário digitou.
        const payload = Object.assign({}, this.dados, {
          data_nascimento: this.paraIso(this.dados.data_nascimento)
        })

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/lista-espera-publica/inscrever`, payload)
          .then(r => {
            this.enviando = false
            if (r.data && r.data.erro) { this.erro = r.data.erro; return }
            this.protocoloGerado = r.data
          })
          .catch(() => {
            this.enviando = false
            this.erro = 'Não foi possível enviar a inscrição. Tente novamente em alguns instantes.'
          })
      })
    },
    paraIso (d) {
      if (!d) return ''
      const p = String(d).split('/')
      return p.length === 3 ? `${p[2]}-${p[1]}-${p[0]}` : d
    }
  }
}
</script>
<style scoped>
/*
   Espaçamento entre rótulo e campo, alinhado ao formulário de inscrição de novatos.

   Aquela tela usa um `<label>` comum dentro do item (sem padding) e item com 10px de
   margem. Aqui usamos o `label` do Element com `label-position="top"`, que traz
   `padding: 0 0 10px` — daí a folga maior. Medido: 10px de padding e 18px de margem
   contra 0 e 10px do modelo.
*/
::v-deep .el-form--label-top .el-form-item__label {
    padding-bottom: 2px;
    line-height: 1.4;
}

::v-deep .el-form-item {
    margin-bottom: 10px;
}

.subtitulo { margin: 22px 0 6px; font-size: 14px; color: #444; border-bottom: 1px solid #eee; padding-bottom: 6px; }
.protocolo-box { text-align: center; margin: 26px 0; padding: 22px; border: 2px dashed #409eff; border-radius: 6px; }
.protocolo-label { display: block; font-size: 13px; color: #666; }
.protocolo-numero { display: block; font-size: 26px; font-weight: bold; letter-spacing: 2px; margin: 10px 0; color: #303133; }
.protocolo-obs { display: block; font-size: 12px; color: #888; }
</style>
